module.exports = __webpack_public_path__ + "static/media/paradise_steak.3691f036.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/paradise_steak.jpg
// module id = 600
// module chunks = 0